export const SUPORTE_WHATSAPP = "5565981228680";

export function linkSuporteWhatsApp(mensagem = "Olá! Preciso de ajuda com a plataforma Lap Clínica.") {
  return `https://wa.me/${SUPORTE_WHATSAPP}?text=${encodeURIComponent(mensagem)}`;
}

export function linkLiberacaoWhatsApp(dados) {
  return linkSuporteWhatsApp([
    "Olá! Acabei de cadastrar uma empresa na plataforma Lap Clínica e gostaria de solicitar a liberação do acesso.",
    "",
    `Empresa: ${dados.nomeEmpresa}`,
    `Responsavel: ${dados.nomeResponsavel}`,
    `E-mail: ${dados.email}`,
    `Telefone: ${dados.telefone}`
  ].join("\n"));
}
